<template>
  <validation-observer
    ref="form-user-login-info"
    tag="form"
  >
    <div class="section">
      <div class="columns">
        <div class="column has-text-centered">
          <h2 class="title is-2">
            User Login Information
          </h2>
          <div class="subtitle is-2">
            Select one or more roles for this user.
          </div>
        </div>
      </div>
      <div class="columns is-multiline">
        <div class="column is-12">
          <div class="message is-info">
            <div class="message-body">
              <p>It's recommended to use the <b>Employee ID</b> as the username if the user works for the City of Philadelphia. Otherwise, if left blank the username will be the user's e-mail address. <i><strong>An e-mail will be sent to the user with information on how to set their password.</strong></i></p>
            </div>
          </div>
        </div>
        <div class="column is-6">
          <textbox-vee
            id="emailAddress"
            v-model="loginInfo.emailAddress"
            rules="required|email"
            required
            placeholder="E-mail"
            autocomplete="off"
          />
        </div>
        <div class="column is-6">
          <textbox-vee
            id="username"
            v-model="loginInfo.username"
            rules=""
            placeholder="Username"
            autocomplete="off"
          />
        </div>
      </div>
    </div>
  </validation-observer>
</template>
<script>
import { controlValueHelpers } from '@/mixins/controlValue';
import { filerScreenHelpers } from '@/mixins/filerScreen';
import { Textbox } from '@phila/phila-ui';
import { withValidation } from 'vee-validate';

const TextboxVee = withValidation(Textbox);

export default {
  name: 'LoginInfoAdmin',
  components: {
    TextboxVee,
  },
  mixins: [
    filerScreenHelpers,
    controlValueHelpers,
  ],
  data() {
    return {
      loginInfo: {
        username: '',
        emailAddress: '',
      },
    };
  },
  computed: {},
  watch: {
    loginInfo: {
      async handler (newValue) {
        this.$emit('loginInfo', newValue);
      },
      deep: true,
    },
  },
  async created () {},
  methods: {},
};
</script>